module.exports = __webpack_public_path__ + "img/sameday_dfod_dg.cbee98f1.png";